import { getDomain } from '@libs/utils';

import type { HotjarEvent } from './hotjarEventsTypes';

declare global {
  interface Window {
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    hj: any;
  }
}

export function trackHotjarEvent(eventName: HotjarEvent): void {
  if (window.hj) {
    window.hj('event', eventName);
  }
}

export function trackHotjarEventWithLocaleRestriction(
  eventName: HotjarEvent,
  allowedLocale: string[]
): void {
  if (allowedLocale.includes(getDomain.getCurrentDomainSpec().Locale)) {
    trackHotjarEvent(eventName);
  }
}
